<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-header-menu-date-filter" v-bind:class="{'selected': isSelected}" v-if="enableFilter && !isDateRageHidden">
    
    <el-dropdown class="wy-header-menu-date-filter-dropdown" ref="dateFilter" placement="top" trigger="click" 
      :hide-on-click="false" @visible-change="handleChangeVisible">
      <span class="el-dropdown-title wy-disable-select">
        <div class="header-title">Date range</div>
        <div class="icon-header-calendar"></div>
        <div class="el-dropdown-date-filter-subtitle">
          {{dateHeader}}<span class="dots"></span>
        </div>
        <i v-bind:class="{'el-icon-caret-right':!isShow, 'angle-up':isShow }" ></i>
      </span>
      
      <el-dropdown-menu class="wy-header-menu-panel wy-header-menu-date-filter-panel" slot="dropdown">
          <div class="menu-panel">
            <div class="date-filer-header">
              <div class="date-header" @click="closePopup"><span class="dots">Filter by date range:</span></div>
              <el-radio-group v-model="dataModel.dateRangeType" @change="handleTypeChange">
                <div :class="{'el-dropdown-menu__item': true, 'is-disabled': item.disabled, 'selected': item.type==dataModel.dateRangeType}" v-for="(item, index) in dataModel.dateRangeOptions" :key="index"> 
                  <el-radio :label="item.type" >{{item.label}}</el-radio>
                </div>
              </el-radio-group>
              <a @click="handleCancel()" class="cancel-btn prevent-select">Cancel</a>
              <el-button class="wy-white-button date-apply" ref="dateApplyBtn" size="mini" @click="handleApply()">{{ $t('button.apply') }}</el-button> 
            </div>
            <div class="date-filer-content">
              <functional-calendar
                ref="calendarPicker"
                v-if="dataModel.dateRangeType==-1" 
                v-model="dataModel.dateCalendar"
                :is-multiple='true' 
                :calendars-count="2"
                :limits="dateLimits"
                :is-date-range='true'
                date-format="yyyy-mm-dd"
                @input="handleDateChange"
              />
            </div>
          </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import FunctionalCalendar from './functional-calendar/FunctionalCalendar'

export default {
  name: 'wy-header-menu-date-filter',
  components: {
    'functional-calendar': FunctionalCalendar
  },
  data() {
    return {
      isShow: false,
      isSelected: false,
    };
  },

  computed: {    
    ...mapGetters(['dataModel', 'shareState', 'isC1Interactions']),

    dateHeader() {
      let sDate = moment(this.dataModel.dateStart,'YYYY-MM-DD').format("MMM Do, YYYY");
      let eDate = moment(this.dataModel.dateEnd,'YYYY-MM-DD').format("MMM Do, YYYY");
      return sDate + ' - ' + eDate;
    },

    dateLimits() {
      if(this.dataModel.dateMin && this.dataModel.dateMax) {
        return {min: this.dataModel.dateMin, max: this.dataModel.dateMax};
      }
      else {
        return null;
      }
    },

    enableFilter() {
      let hasChanaged = this.$store.state.site.changed;
      if(hasChanaged) {
        return this.dataModel.hasFilter;
      }
      else {
        return false;
      }
    },

    isDateRageHidden() {
      let widget = this.$route.meta.headerMenuItems.find(el=>{
        return el.name == 'date-widget'
      })
      let isHidden = false;
      if((widget && widget.properties.hidden) || widget == undefined){
        isHidden = true
      }
      return isHidden;
    },
  },

  methods: {
    ...mapActions(['applyDateValue']),
    
    handleDateChange() {      
      setTimeout(() => {
        document.querySelectorAll(".vfc-base-start").forEach(el=> {
          if(el.nextSibling.nextSibling.classList.contains("vfc-hide")) {
            el.style.display = "none";
          }
          else {
            el.style.display = "block"
            el.style.backgroundColor="#004A87"
          }
        })
        document.querySelectorAll(".vfc-base-end").forEach(el=> {
          if(el.nextSibling.classList.contains("vfc-hide")) {
            el.style.display = "none";
          }
          else {
            el.style.display = "block"
            el.style.backgroundColor="#004A87"
          }
        })
      },200)
    },

    handleTypeChange(type) {
      const selectedRangeOption = this.dataModel.dateRangeOptions.find(el => el.type == type);
      if(selectedRangeOption) {        
        if(selectedRangeOption.start && selectedRangeOption.end) {
          if(typeof selectedRangeOption.start !== 'object') {
            // fixed that when we reload the page, the moment is not parsed from the sessionStorage
            selectedRangeOption.start = moment(selectedRangeOption.start, "YYYY-MM-DD");
            selectedRangeOption.end = moment(selectedRangeOption.end, "YYYY-MM-DD");
          }

          this.dataModel.dateCalendar.dateRange.start = selectedRangeOption.start.format("YYYY-MM-DD");
          this.dataModel.dateCalendar.dateRange.end = selectedRangeOption.end.format("YYYY-MM-DD"); 
        }
      }
      this.initCalendar();
    },
    
    handleChangeVisible(isOpen) {
      if(isOpen) {
        this.$refs.dateFilter.show();
        this.$refs.dateFilter.popperElm.style.transitionDelay = "0s";
        this.isShow = true;
        this.isSelected = true;
        this.dataModel.dateCalendar.lastDateRange = JSON.parse(JSON.stringify(this.dataModel.dateCalendar.dateRange));
        const eventInfo = {
          filter_group_name: 'Date range'
        }
        if(!this.isC1Interactions) this.$router.logAmplitudeEvent({eventName: "GlobalFilter_Opened", eventInfo});
        this.initCalendar();
      }
      else {
        this.$root.$emit(`date-filter-change-events`,this.dataModel.dateRangeInDays);
        this.$refs.dateFilter.hide();
        this.$refs.dateFilter.popperElm.style.transitionDelay = "0.1s";
        this.isSelected = false;
        
      }

      // fire global click overlay event to show the modal
      this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: this.handleApply, active: isOpen});
    },

    initCalendar() {
      if(this.dataModel.dateRangeType == -1) {
        let startObj = moment(this.dataModel.dateCalendar.dateRange.start,'YYYY-MM-DD');
        let endObj = moment(this.dataModel.dateCalendar.dateRange.end,'YYYY-MM-DD');
        this.$refs.calendarPicker.selectDateRange(startObj.format('YYYY-M-D'), endObj.format('YYYY-M-D'));
        this.$refs.calendarPicker.markChooseDays();
        this.$refs.calendarPicker.pickYear(startObj.toDate().getYear()+1900, 0);
        this.$refs.calendarPicker.pickMonth(startObj.toDate().getMonth(), 0);
        this.$refs.calendarPicker.updateLimits(this.dateLimits);
      }
    },

    closePopup() {
      if(this.$refs.dateFilter.visible){
        this.$refs.dateFilter.visible = false;
        this.$refs.dateFilter.$el.classList.remove('opened');
      }
    },

    handleCancel() {
      this.dataModel.dateCalendar.dateRange = JSON.parse(JSON.stringify(this.dataModel.dateCalendar.lastDateRange));
      this.closePopup();
    },

    async handleApply() {
      this.isShow = false;
      this.isSelected = false;

      //if single selection, then call handlecancel
      if(this.dataModel.dateCalendar.dateRange.start && (this.dataModel.dateCalendar.dateRange.end == "")){
        if(this.dataModel.dateStart != this.dataModel.dateCalendar.dateRange.start || this.dataModel.dateEnd != this.dataModel.dateCalendar.dateRange.end) {
          this.handleCancel()
        }
      }

      if(this.dataModel.dateCalendar.dateRange.start && this.dataModel.dateCalendar.dateRange.end) {
        if(this.dataModel.dateStart != this.dataModel.dateCalendar.dateRange.start || this.dataModel.dateEnd != this.dataModel.dateCalendar.dateRange.end) {          
          this.applyDateValue();
          this.$root.fireEvent({name: 'handleFilterChange', type: 'Global Filter: Date'});
          // if(isFromApplyBtn) {
          const eventInfo = {
            filter_group_name: 'Date range'
          }
          if(!this.isC1Interactions) this.$router.logAmplitudeEvent({eventName: "GlobalFilter_Applied", eventInfo});
          // }
        }
        else {
          this.dataModel.dateHasChanged = false;
        }
      }
      this.closePopup();
    },
  }
}
</script>

<style lang="scss">
.wy-header-menu-date-filter {
  .angle-up {
    background-image: var(--header-drop-down-arrow-up);
    background-repeat: no-repeat;
    background-color: transparent;
    border: none;
    padding: 0;
    top: 27px;
    position: relative;
    height: 20px;
    right: 18px;
    background-size: 10px;
    width: 11px;
    float: right;
    margin-right: 0px;
  }
  &:hover{
    // background: rgba(229, 234, 242, 0.09) !important;
  }
  display: inline-block;
  height: calc(100% - 3px);
  .wy-header-menu-date-filter-dropdown {
    .el-dropdown-title {
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      color: #FFF;
      outline: none !important;
      .el-dropdown-date-filter-subtitle{
        padding-right: 7px;
        display: inline-block;
        font-size: 15px;
        left: 11px;
      }
      .el-icon-caret-right {
        background-image: var(--header-drop-down-arrow-down);
        background-repeat: no-repeat;
        background-size: 10px 10px;
        background-position-x: 0px;
        background-position-y: 0px;
        width: 11px;
        position: relative;
        top: 20px;
        right: 18px;
        height: 10px;
        vertical-align: middle;
      }
    }
  }
  .wy-header-menu-date-filter-dropdown {
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: 6px;
    background-size: 5px 8px;
    text-align: right;
    width: 310px;
    margin: 0px 0px 0px 0px;
    padding: 12px 0px 0 0px;
    border-radius: 5px;
    opacity: 1;
    height: 74px;
    top: -15px;
    .dots {
      display: none;
    }
  }
  .wy-header-menu-date-filter-dropdown:hover {
    background-color: none !important;
  }
  //.wy-header-menu-date-filter-dropdown:hover {
    // background: #EBF4FD 0% 0% no-repeat padding-box;
  //}
  .wy-header-menu-date-filter-dropdown.opened {
    background-position-y: 8px;
    background-size: 8px 5px;
    text-align: left;
    .el-dropdown-title {
      color: #FFF !important;
      font-weight: 500;
    }
    .dots {
      display: inline-block !important;
    }
  }
  .icon-header-calendar {
    background-image: var(--header-icon-calendar);
    background-repeat: no-repeat;
    background-size: 12px 12px;
    background-position-x: 0px;
    background-position-y: 0px;
    width: 15px !important;
    height: 12px;
    position: relative;
    left: -31px;
    top: 22px;
    display: inline-block;
  }
  .el-icon-caret-right:before {
    content: "";
  }
  .el-range-editor.el-input__inner{
    padding: 3px 0px;
  }
  .wy-header-menu-date-filter-picker {
    visibility: hidden !important;
    width: 1px !important;
    height: 10px !important;
  }

  .wy-header-menu-date-filter-picker-panel {
    position: relative !important;
    top: -1126px !important;
    z-index: 9999 !important;
    .el-date-table td.prev-month {
      color: #B3B3B3;
      background-color: #F5F5F5;
      visibility: hidden;
    }
    .el-date-table td.next-month {
      visibility: hidden;
    }
    .el-date-table th {
      background-color: #EBF4FD;
      color: #214586;
    }
    .el-date-table td.start-date span,
    .el-date-table td.end-date span {
      background-color: var(--site-font-primary-color) !important;
    }
    .el-date-table td.in-range div {
      background-color: #214586 !important;
      color: white !important;
    }
    .el-date-table td span:hover {
      // color: #ffffff;
      font-weight: 900;
    }
    .el-date-table td.today span {
      color: #214586;
      font-weight: 700;
    }
    .el-date-table td.disabled:not(.in-range) span{
      background: 
          linear-gradient(to top left,
              rgba(0,0,0,0) 0%,
              rgba(0,0,0,0) calc(50% - 0.8px),
              rgba(165, 165, 165, 0.658) 50%,
              rgba(0,0,0,0) calc(50% + 0.8px),
              rgba(0,0,0,0) 100%),
    }

    .el-date-range-picker__content {
      padding: 7px 16px;

      .el-date-table th {
        padding: 0px 5px;
      }
      .el-date-table td {
        padding: 0;
      }
    }
  }
  // .popper__arrow {
  //   //display: none !important;;
  // }
}

.wy-header-menu-date-filter.selected {
  position: relative;
  z-index: 9999;
  background: var(--nav-top-background-color-selected) 0% 0% no-repeat padding-box !important;
}

.wy-header-menu-date-filter-panel {
  // top: 21px !important;
  top: 0px !important;
  box-shadow: none;
  background: transparent 0% 0% no-repeat padding-box;
  // overflow-x: auto;
  // overflow-y: hidden;

  .menu-panel {
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
    box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
    background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
    padding: 0;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    width: 1020px;
    height: 498px;
    min-width: 935px;
    // border-top: 1px solid #C9D3DA;
    box-shadow: 0px 4px 10px rgba(74, 74, 74, 0.25);
    border-radius: 0px 0px 5px 5px;
  }
  .wy-white-button.date-apply {
    width: 104px;
    height: 30px;
    border-radius: 5px;
    border: 1px white solid;
    left: calc(100% + 681px);
    top: 408px;
    background-color: #F4F6F8;
    padding-top: 6px;
    font-size: 14px;
    box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    background-color: var(--top-menu-panel-global-filter-primary-btn-background-color) !important;
    border: 1px white solid;
    border-radius: 5px;
    color: var(--top-menu-panel-global-filter-primary-btn-text-color);
    font-size: 14px;
    align-content: center;
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    position: relative;
    
    &:hover{
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: var(--top-menu-panel-global-filter-primary-btn-hover-background-color) !important;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-hover-text-color) !important;
      font-size: 14px;
      align-content: center;
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    }
    &:active {
      background-color: var(--top-menu-panel-global-filter-primary-btn-pressed-background-color) !important;
    }
    &:focus {
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: unset;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-text-color) !important;
    }
    span {
      position: relative;
      top: 1px;
    }
  }
  .date-filer-header {
    display: inline-block;
    padding-top: 15px;
    .cancel-btn {
      color: var(--top-menu-panel-global-filter-cancel-btn-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      position: relative;
      top: 410px;
      left: 30px;
      cursor: pointer;
    }
  }
  .el-radio{
    height: 22px !important;
    width: 263px !important;
    position: relative;
    left: 6px;
  }
  .el-radio-group {
    width: 1020px;
    height: 388px;
    position: absolute;
    border-bottom: 1px var(--top-menu-panel-global-filter-divider-color) solid;
  }
  .el-radio__inner {
    // border: 1px solid #cfcfcf !important;
    border: 1px solid var(--top-menu-panel-global-filter-radio-button-border-color) !important;
    border-radius: 100%;
    width: 10px !important;
    height: 10px !important;
    // background: #020e14;
    background: var(--top-menu-panel-global-filter-radio-button-background-color);
    -webkit-box-shadow: unset !important;
    box-shadow: unset !important;
  }
  .el-radio__inner:hover {
    // background: #353E43;
    background: var(--top-menu-panel-global-filter-radio-button-checked-background-color);
  }
  .el-radio__inner::after {
    width: 5px;
    height: 5px;
    border-radius: 50px;
    background-color: var(--top-menu-panel-global-filter-radio-button-color);
  }
  .el-radio__label{
    // color: #CFCFCF;
    color: var(--top-menu-panel-calendar-text-color);
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: var(--top-menu-panel-calendar-text-checked-color);
  }
  input.is-checked{
    height: 10px !important;
    color: var(--top-menu-panel-calendar-text-color);
    margin-right: 9px;
  }
  
  .el-radio__input.is-checked .el-radio__inner {
    // background: #020e14;
    background: var(--top-menu-panel-global-filter-radio-button-checked-background-color);
  }
  // calendar css 
  .date-filer-content {
    position: relative;
    top: 45px;
    left: 20px;
    height: 280px;
    width: 621px;
    .vfc-main-container {
      // background-color: #0F1A20;
      background-color: var(--top-menu-panel-calendar-background-color);
      height: 300px;
      border-radius: 10px;
      border: 1px solid var(--top-menu-panel-calendar-border-color);
      box-shadow: var(--top-menu-panel-calendar-shadow);
      box-sizing: border-box;
      line-height: 24px;
      position: relative;
      left: 188px;
      top: 26px;
    }
    .vfc-calendars-container.disable-hidden {
      .disabled-right-arrow {
        position: relative;
        left: 591px;
        top: 15px;
        width: 5px;
        height: 5px;
        border-top: 2px solid;
        border-right: 2px solid;
        border-color: #eee;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        border-radius: 5px;
      }
      .disabled-left-arrow {
        position: relative;
        left: 20px;
        top: 20px;
        width: 5px;
        height: 5px;
        border-top: 2px solid;
        border-right: 2px solid;
        border-color: #eee;
        -webkit-transform: rotate(225deg);
        transform: rotate(225deg);
        border-radius: 5px;
      }
      .vfc-navigation-buttons div .vfc-arrow-left, .vfc-separately-navigation-buttons div .vfc-arrow-left.vfc-disabled, 
      .vfc-navigation-buttons div .vfc-arrow-right, .vfc-separately-navigation-buttons div .vfc-arrow-right.vfc-disabled {
        display: none;
      }
    }
    .vfc-calendars-container {
      .vfc-calendar {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
        // border-bottom: 1px #2c2c2c solid !important;
        height: 240px !important;
        // border-right: 1px #2c2c2c solid !important;
        border-bottom: 1px var(--top-menu-panel-calendar-inside-divider-color) solid !important;
        border-right: 1px var(--top-menu-panel-calendar-inside-divider-color) solid !important;
      }
      .vfc-calendars {
        .vfc-content .vfc-week .vfc-monday:before {
          border-top-left-radius: 5px !important;
        }
        .vfc-content .vfc-week .vfc-first-day-of-month:before {
          border-top-left-radius: 5px !important;
        }
        .vfc-content .vfc-week .vfc-last-monday:before {
          border-bottom-left-radius: 5px !important;
        }
        .vfc-content .vfc-week .vfc-sunday:before {
          border-top-right-radius: 5px !important;
        }
        .vfc-content .vfc-week .vfc-last-sunday:before {
          border-bottom-right-radius: 5px !important;
        }
        .vfc-content .vfc-week .vfc-end-day-of-month:before {
          border-bottom-right-radius: 5px !important;
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-hover:hover {
          background-color: var(--top-menu-panel-calendar-text-selected-date-start-end-hover-background-color);
          z-index: 0;
          font-weight: 600 !important;
          color: var(--top-menu-panel-global-filter-header-text-color) !important;
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-start-marked.vfc-hover:hover {
          z-index: 100 !important;
          background-color: transparent !important;
        }
        .vfc-content {
          margin-bottom: 5px;
        }
        .vfc-top-date {
          margin: 15px;
          font-size: 12px;
          font-weight: 600;
        }
        .vfc-top-date span {
          // color: #F8F7FA;
          color: var(--top-menu-panel-calendar-text-highlight-color);
        }
        .vfc-dayNames span {
          // color: #F8F7FA;
          color: var(--top-menu-panel-calendar-text-highlight-color);
          font-size: 12px;
          font-weight: 600;
        }
        
        .vfc-week .vfc-day span.vfc-span-day {
          font-size: 12px;
          font-weight: 400;
          width: 20px;
          line-height: 20px;
          margin: 0px 0px !important;
        }
        .vfc-week .vfc-day {
          margin-top: 0px;
          padding-top: 3px;
          padding-bottom: 1px;
          padding-left: 10px;
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-marked {
          // background-color: #353E43;
          background-color: var(--top-menu-panel-calendar-text-selected-date-start-end-background-color);
          border-radius: 50%;
          // color: #F8F7FA;
          color: var(--top-menu-panel-calendar-text-highlight-color) !important;
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-start-marked:before, .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-end-marked:before {
          border-radius: 50%;
          // background-color: #C9D8F3 !important;
          background-color: var(--top-menu-panel-calendar-text-selected-date-start-end-background-color) !important;
          
          margin: 0px;
          width: 40px;
        }
       .vfc-week .vfc-day span.vfc-span-day.vfc-today {
          background-color: #020E14;
          color: white !important;
          border: 1px #DDE0E3 solid;
        }
        .vfc-start-marked,.vfc-end-marked{
          z-index: 100;
          color: #000000 !important;
        }
        .vfc-week .vfc-day span.vfc-span-day {
          display: inline-block;
          text-align: center;
          border-radius: 20%;
          margin: 0;
          vertical-align: middle;
          // color: #C9C8CC;
          color: var(--top-menu-panel-calendar-text-color);
        }
        // .vfc-week .vfc-day span.vfc-span-day.vfc-marked:before {
        //   // background-color: #0C2837;
        // }
        .vfc-week .vfc-day span.vfc-span-day.vfc-marked:before {
          // height: 26px;
          height: var(--top-menu-panel-calendar-text-selected-date-height);
          background-color: var(--top-menu-panel-calendar-text-selected-date-background-color);
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-start-marked.vfc-end-marked:before {
          border-radius: 20% !important;
        }
      
        .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-start-marked:before {
          background-color: #0C2837;
          border-radius: 20%!important;
          border-top-left-radius: 20%!important;
          border-bottom-right-radius: 0%!important;
          border-top-right-radius: 0%!important;
          border: 1px var(--top-menu-panel-calendar-text-selected-date-start-end-border-color) solid;
          // height: 24px;
          // width: 38px;
          height: var(--top-menu-panel-calendar-text-selected-date-start-end-height);
          width: var(--top-menu-panel-calendar-text-selected-date-start-end-width);
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-end-marked:before {
          background-color: #0C2837;
          border-bottom-left-radius: 0%!important;
          border-top-left-radius: 0%!important;
          border-bottom-right-radius: 20%!important;
          border-top-right-radius: 20%!important;
          border: 1px var(--top-menu-panel-calendar-text-selected-date-start-end-border-color) solid;
          height: var(--top-menu-panel-calendar-text-selected-date-start-end-height);
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-hide {
          color: #FFF;
          background-color: #FFF !important;
          display: none;
        }
        .vfc-week .vfc-day span.vfc-span-day.vfc-hide:before {
          color: #FFF;
          background-color: #FFF !important;
          display: none;
        }
      }
      .vfc-separately-navigation-buttons {
        margin-top: 0px;
      }
      .vfc-navigation-buttons div, .vfc-separately-navigation-buttons div {
        color: var(--top-menu-panel-calendar-top-arrows-color);
        margin: 10px 10px 10px 10px;
        background-color: var(--top-menu-panel-calendar-top-arrows-background-color);
        border-radius: 5px;
      }
      .vfc-navigation-buttons div .vfc-arrow-left, .vfc-separately-navigation-buttons div .vfc-arrow-left, 
      .vfc-navigation-buttons div .vfc-arrow-right, .vfc-separately-navigation-buttons div .vfc-arrow-right {
        width: 5px;
        height: 5px;
        // border-color: #F8F7FA;
        border-color: var(--top-menu-panel-calendar-text-highlight-color);
      }
      .vfc-navigation-buttons div .vfc-arrow-left, .vfc-separately-navigation-buttons div .vfc-arrow-left.vfc-disabled, 
      .vfc-navigation-buttons div .vfc-arrow-right, .vfc-separately-navigation-buttons div .vfc-arrow-right.vfc-disabled {
        border-color: #5e5d60;
      }
      // .vfc-base-start:hover, .vfc-base-end:hover {
      //   background-color: var(--top-menu-panel-calendar-text-selected-date-hover-background-color) !important;
      // }
      .vfc-week .vfc-day .vfc-base-start:first-of-type + span:hover {
        background-color: transparent !important;
      }
      .vfc-week .vfc-day .vfc-base-end:first-of-type + span:hover {
        background-color: transparent !important;
      }
      .vfc-week .vfc-day .vfc-base-start {
        // width: 65% !important;
        // background-color: #0C2837 !important;
        // border: 1px #000 solid;
        // border-right-width: var(--top-menu-panel-calendar-text-selected-date-start-end-border-right) !important;
        // border-top-left-radius: 10px !important;
        // border-bottom-left-radius: 10px !important;
        top: 0px;
        // left: 2px;
        background-color: transparent !important;//var(--top-menu-panel-calendar-text-selected-date-start-end-background-color) !important;
        // height: calc(100% - 2px);
        // width: 90% !important;
        // z-index: var(--top-menu-panel-calendar-z-index);
      }
      .vfc-base-start:first-child  {
        background-color: var(--top-menu-panel-calendar-text-selected-date-start-end-background-color) !important;
      }
      // .vfc-week .vfc-day .vfc-base-start:hover {
      //   background-color: transparent !important;
      // }
      .vfc-week .vfc-day .vfc-base-end {
        // background-color: #0C2837 !important;
        // border: 1px #000 solid;
        // border-right-width: var(--top-menu-panel-calendar-text-selected-date-start-end-border-right) !important;
        // border-top-right-radius: 10px !important;
        // border-bottom-right-radius: 10px !important;
        top: 0px;
        // left: 0px;
        // background-color: var(--top-menu-panel-calendar-text-selected-date-start-end-background-color) !important;
        background-color: var(--top-menu-panel-calendar-text-selected-date-under-background-color) !important;
        // height: calc(100% - 2px);
        // width: 90% !important;
        // z-index: var(--top-menu-panel-calendar-z-index);
        // background-color: transparent !important;
      }
    }
  }
  .date-header {
    // color: #214586;
    color: var(--top-menu-panel-global-filter-header-text-color);
    padding-left: 28px;
    cursor: pointer;
    margin-bottom: 8px;
    // width: 400px;
  }
  .date-filer-header .date-header .dots {
    font-weight: var(--top-menu-panel-global-filter-header-text-font-weight);
    font-size: var(--top-menu-panel-global-filter-header-text-font-size);
  }
}
.wy-header-menu-date-filter-panel.el-dropdown-menu  {
  // min-width: 250px !important;
  width: min-content;
  border-radius: 0px;
  width: 1021px;
  // left: 301px !important;
  left: var(--site-top-menu-filtering-panel-left) !important;
  margin: 64px 0 5px 0 !important;
  
  .el-dropdown-menu__item{
    margin: 7px 8px 7px 10px;
    border: 0.5px solid transparent;
    color: #F4F6F8;
    font-size: 14px;
    font-weight: 500;
    width: 242px;
    border-radius: 5px;
    padding:0px 20px 0px 10px;
    line-height: 30px;
    margin: 20px 0px -3px 19px;
    margin-left: 27px;
    .checkedIcon{
      float: right;
      color: #ffffff;
    }
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: var(--top-menu-panel-calendar-text-unselected-hover-background-color);
    .checkedIcon{
      color: #EBF4FD;
    }
    color: #F4F6F8;
  }

  .el-dropdown-menu__item.is-disabled {
    color: #F4F6F8 !important;
    font-size: 14px;
    font-weight: 500;
    opacity: 0.5;
  }

  .el-dropdown-menu__item.selected {
    // color: #ffffff  !important;
    // border: 0.5px solid #FFFFFF;
    // background-color: #1b262b !important;
    background-color: var(--top-menu-panel-calendar-text-selected-background-color);
    box-sizing: border-box;
    border-radius: 5px;
    width: 274px;
    height: 33px;
    padding-top: 0px;
    margin-top: 20px;
    .checkedIcon{
      background-image: url('../../assets/icons/icon_white_check.svg');
      background-repeat: no-repeat;
      background-size: 15px 15px;
      background-position-x: 3px;
      background-position-y: 7px;
      width: 20px;
      height: 30px;
      vertical-align: middle;
    }
  }
  .el-dropdown-menu__item.selected:hover {
    // background-color: rgba(229, 234, 242, 0.09) !important;
    background-color: var(--top-menu-panel-calendar-text-hover-background-color) !important;
  }
  .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange {
    width: 200px;
  }
  .el-date-editor .el-range-input, .el-date-editor .el-range-separator {
    font-size: 10px;
  }
}
</style>
